import { createSelector as _createSelector } from "reselect";

import { ApplicationState } from "../store/app";

// Expose createSelector from reselect so we can wrap it later in one place easily
export const createSelector = _createSelector;
export type Selector<T> = <T>(state: ApplicationState, props?: any) => T;
